var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 201,
    height: 132,
    viewBox: "0 0 201 132",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.63 17.2598H54.8301C53.118 17.2598 51.7301 18.6477 51.7301 20.3598V74.1598C51.7301 75.8718 53.118 77.2598 54.8301 77.2598H140.63C142.342 77.2598 143.73 75.8718 143.73 74.1598V20.3598C143.73 18.6477 142.342 17.2598 140.63 17.2598Z",
    fill: "#CBCBCB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8301 17.2598H140.63C141.452 17.2598 142.241 17.5864 142.822 18.1677C143.404 18.7491 143.73 19.5376 143.73 20.3598V26.2598H51.7301V20.3598C51.7301 19.9527 51.8103 19.5496 51.9661 19.1734C52.1219 18.7973 52.3502 18.4556 52.6381 18.1677C52.9259 17.8799 53.2677 17.6515 53.6438 17.4957C54.0199 17.3399 54.423 17.2598 54.8301 17.2598Z",
    fill: "#8F8E8E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2301 23.2598C58.0585 23.2598 58.7301 22.5882 58.7301 21.7598C58.7301 20.9313 58.0585 20.2598 57.2301 20.2598C56.4017 20.2598 55.7301 20.9313 55.7301 21.7598C55.7301 22.5882 56.4017 23.2598 57.2301 23.2598Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2301 23.2598C64.0585 23.2598 64.7301 22.5882 64.7301 21.7598C64.7301 20.9313 64.0585 20.2598 63.2301 20.2598C62.4017 20.2598 61.7301 20.9313 61.7301 21.7598C61.7301 22.5882 62.4017 23.2598 63.2301 23.2598Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2301 23.2598C70.0585 23.2598 70.7301 22.5882 70.7301 21.7598C70.7301 20.9313 70.0585 20.2598 69.2301 20.2598C68.4017 20.2598 67.7301 20.9313 67.7301 21.7598C67.7301 22.5882 68.4017 23.2598 69.2301 23.2598Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.28 32.9697H58.28V57.9897H80.28V32.9697Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.28 46.2597C71.9199 46.2597 74.06 44.1196 74.06 41.4797C74.06 38.8398 71.9199 36.6997 69.28 36.6997C66.6401 36.6997 64.5 38.8398 64.5 41.4797C64.5 44.1196 66.6401 46.2597 69.28 46.2597Z",
    fill: "#FFCE51"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8701 48.8599H63.7001V50.4899H74.8701V48.8599Z",
    fill: "#FFCE51"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8701 52.8696H63.7001V54.4996H74.8701V52.8696Z",
    fill: "#FFCE51"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107.59 32.9697H85.5901V57.9897H107.59V32.9697Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M102.18 48.8599H91.01V50.4899H102.18V48.8599Z",
    fill: "#8F8E8E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M102.18 52.8696H91.01V54.4996H102.18V52.8696Z",
    fill: "#8F8E8E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M134.9 32.9697H112.9V57.9897H134.9V32.9697Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M120.13 44.9099C122.008 44.9099 123.53 43.3876 123.53 41.5099C123.53 39.6321 122.008 38.1099 120.13 38.1099C118.252 38.1099 116.73 39.6321 116.73 41.5099C116.73 43.3876 118.252 44.9099 120.13 44.9099Z",
    fill: "#FFCE51"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M101.38 36.6997H91.8101V46.2697H101.38V36.6997Z",
    fill: "#61B8FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M126.93 46.7896H120.14V53.5796H126.93V46.7896Z",
    fill: "#7FDD53"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M124.14 44.6597L127.66 38.4697L131.19 44.6597H124.14Z",
    fill: "#FF7324"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8101 36.6997L101.37 46.2597",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M101.37 36.6997L91.8101 46.2597",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5 40.5097C71.5 40.5097 79.67 35.1497 87.85 40.1497",
    stroke: "#FF7324",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M88.11 41.4398C88.712 41.4398 89.2 40.9518 89.2 40.3498C89.2 39.7478 88.712 39.2598 88.11 39.2598C87.508 39.2598 87.02 39.7478 87.02 40.3498C87.02 40.9518 87.508 41.4398 88.11 41.4398Z",
    fill: "#FF7324"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M103.43 47.3198C103.43 47.3198 110.11 51.6998 116.79 47.6198",
    stroke: "#FF7324",
    strokeWidth: 0.82,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M117.01 48.3396C117.502 48.3396 117.9 47.9411 117.9 47.4496C117.9 46.958 117.502 46.5596 117.01 46.5596C116.518 46.5596 116.12 46.958 116.12 47.4496C116.12 47.9411 116.518 48.3396 117.01 48.3396Z",
    fill: "#FF7324"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2101 68.8997L91.0201 70.7097L95.0101 66.7197",
    stroke: "#7FDD53",
    strokeWidth: 0.93,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5 65.5996C99.5 65.5996 79.06 60.4296 79.6 67.5196C80.14 74.6096 102.44 75.5896 104.53 68.8496C106.62 62.1096 95.82 62.0796 95.82 62.0796",
    stroke: "#FF7324",
    strokeWidth: 1.24,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M79.02 91.8198H33.22C31.5079 91.8198 30.12 93.2077 30.12 94.9198V111.17C30.12 112.882 31.5079 114.27 33.22 114.27H79.02C80.7321 114.27 82.12 112.882 82.12 111.17V94.9198C82.12 93.2077 80.7321 91.8198 79.02 91.8198Z",
    fill: "#CBCBCB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5701 95.3599H63.2101V110.72H78.5701V95.3599Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M36.62 95.3599H36.61C34.9808 95.3599 33.66 96.6806 33.66 98.3099V98.3199C33.66 99.9491 34.9808 101.27 36.61 101.27H36.62C38.2493 101.27 39.57 99.9491 39.57 98.3199V98.3099C39.57 96.6806 38.2493 95.3599 36.62 95.3599Z",
    fill: "#FF7324"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M33.66 105.34H57.3",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M33.66 108.96H52.38",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M43.12 98.3198H57.3",
    stroke: "#8F8E8E",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M23.71 64.4499L24.11 61.3799C24.3151 59.8353 25.0156 58.3989 26.1065 57.2864C27.1974 56.1738 28.6198 55.4452 30.16 55.2099L32.16 54.9099L30.16 54.6099C28.6206 54.3766 27.1985 53.65 26.1075 52.5391C25.0165 51.4283 24.3155 49.9933 24.11 48.4499L23.71 45.3799L23.3 48.4499C23.1004 49.9873 22.4077 51.4186 21.326 52.5292C20.2443 53.6398 18.8317 54.3698 17.3 54.6099L15.3 54.9099L17.3 55.2099C18.8325 55.452 20.2453 56.184 21.3269 57.2963C22.4086 58.4086 23.1008 59.8413 23.3 61.3799L23.71 64.4499Z",
    fill: "#FFCE51"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M36.35 44.2095L36.51 43.7495C36.818 42.8501 37.3159 42.0273 37.9698 41.3372C38.6237 40.647 39.4184 40.1055 40.3 39.7495C39.4198 39.3913 38.6263 38.8491 37.9727 38.1592C37.319 37.4694 36.8203 36.6478 36.51 35.7495L36.35 35.2896L36.2 35.7495C35.8897 36.6478 35.3911 37.4694 34.7374 38.1592C34.0838 38.8491 33.2903 39.3913 32.41 39.7495C33.2916 40.1055 34.0863 40.647 34.7403 41.3372C35.3942 42.0273 35.8921 42.8501 36.2 43.7495L36.35 44.2095Z",
    fill: "#8F8E8E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M36.35 72.1097C37.4877 72.1097 38.41 71.1875 38.41 70.0498C38.41 68.912 37.4877 67.9897 36.35 67.9897C35.2123 67.9897 34.29 68.912 34.29 70.0498C34.29 71.1875 35.2123 72.1097 36.35 72.1097Z",
    fill: "#8F8E8E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M171.89 84.3498L171.5 81.2798C171.299 79.743 170.606 78.3125 169.524 77.2022C168.443 76.0919 167.031 75.3614 165.5 75.1198L163.5 74.8198L165.5 74.5198C167.032 74.2761 168.444 73.5436 169.525 72.4316C170.606 71.3197 171.299 69.8878 171.5 68.3498L171.91 65.2798L172.31 68.3498C172.513 69.895 173.214 71.3322 174.305 72.4451C175.396 73.5579 176.819 74.286 178.36 74.5198L180.36 74.8198L178.36 75.1198C176.82 75.3515 175.397 76.0777 174.306 77.1888C173.214 78.2999 172.514 79.7358 172.31 81.2798L171.89 84.3498Z",
    fill: "#FFCE51"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M159.84 63.9996L159.68 63.5396C159.373 62.6398 158.875 61.8168 158.221 61.1265C157.567 60.4363 156.772 59.895 155.89 59.5396C156.773 59.1853 157.568 58.6444 158.222 57.954C158.877 57.2636 159.374 56.44 159.68 55.5396L159.84 55.0796L160 55.5396C160.306 56.44 160.803 57.2636 161.458 57.954C162.112 58.6444 162.907 59.1853 163.79 59.5396C162.908 59.895 162.113 60.4363 161.459 61.1265C160.805 61.8168 160.307 62.6398 160 63.5396L159.84 63.9996Z",
    fill: "#8F8E8E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M160.84 91.7396C161.978 91.7396 162.9 90.8173 162.9 89.6796C162.9 88.5419 161.978 87.6196 160.84 87.6196C159.702 87.6196 158.78 88.5419 158.78 89.6796C158.78 90.8173 159.702 91.7396 160.84 91.7396Z",
    fill: "#8F8E8E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M17.53 127.72H183.31",
    stroke: "#CBCBCB",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M153.07 32.4997C153.07 38.4202 157.87 43.2197 163.79 43.2197C169.711 43.2197 174.51 38.4202 174.51 32.4997C174.51 26.5792 169.711 21.7797 163.79 21.7797C157.87 21.7797 153.07 26.5792 153.07 32.4997Z",
    fill: "#7FDD53"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M158.88 32.9995L161.87 35.9895L168.33 29.5195",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M113.16 77.1697L106.08 73.0897L105.53 72.0297L106.72 71.9697L113.8 76.0497L113.16 77.1697Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M161.84 122.61C161.84 122.61 163.97 122.84 164.79 121.7L173.32 127.47C173.32 127.47 169.56 128.6 167.38 127.19C165.2 125.78 161.84 126.83 161.84 126.83V122.61Z",
    fill: "#250E0D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M131.32 105.58L134.58 125.58C134.677 126.184 134.986 126.734 135.451 127.132C135.917 127.529 136.508 127.748 137.12 127.75H162.04V122.09L143.04 119.98L142.97 111.88C142.97 111.88 145.63 103.3 143.31 98.46L131.32 105.58Z",
    fill: "#675EBF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M116.58 121.09V122.93C116.581 123.308 116.508 123.684 116.363 124.034C116.219 124.384 116.007 124.702 115.739 124.969C115.472 125.237 115.154 125.449 114.804 125.593C114.454 125.738 114.079 125.811 113.7 125.81H112.7C112.119 125.81 111.562 126.041 111.151 126.451C110.741 126.862 110.51 127.419 110.51 128H120.91V121.09H116.58Z",
    fill: "#250E0D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M128.11 95.8297L115.39 95.0597C114.913 95.0305 114.435 95.1085 113.991 95.2877C113.548 95.467 113.15 95.7431 112.827 96.0958C112.504 96.4485 112.264 96.869 112.125 97.3264C111.985 97.7838 111.949 98.2667 112.02 98.7397L115.66 123.22H121.92L121.65 104.36C121.65 104.36 140.82 113.52 142.06 99.8497L128.11 95.8297Z",
    fill: "#897DFF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M135.12 76.9998L134.64 71.8398L134.92 67.0498L129.25 65.5698C128.25 67.4998 127.12 70.5698 128.25 72.6598C128.449 72.9737 128.741 73.2181 129.085 73.3595C129.428 73.501 129.808 73.5325 130.17 73.4498L129.99 76.1198L135.12 76.9998Z",
    fill: "#A48165"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M131.92 70.7597C134.32 74.6397 136.79 70.5297 137.43 68.4497C137.576 67.8122 137.561 67.1485 137.386 66.5182C137.212 65.888 136.883 65.3111 136.43 64.8397C135.07 63.1297 132.86 60.3497 130.31 61.1197C129.52 61.3932 128.869 61.9648 128.495 62.7123C128.122 63.4598 128.055 64.3238 128.31 65.1197C128.818 66.3508 129.752 67.3586 130.94 67.9597C130.867 68.2306 130.854 68.5143 130.903 68.7907C130.951 69.0672 131.059 69.3297 131.22 69.5597C131.22 69.5597 132.22 67.5597 133.06 68.5597C133.9 69.5597 131.92 70.7597 131.92 70.7597Z",
    fill: "#250E0D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M143.08 82.7197L144.77 88.4697C144.913 88.9585 144.904 89.479 144.745 89.9628C144.586 90.4465 144.285 90.8708 143.88 91.1797L141.98 92.6297L139.26 83.4797L143.08 82.7197Z",
    fill: "#A48165"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M121.7 82.2397L119.5 83.9997L111.78 77.3697L111.36 75.1797C111.287 74.7155 111.075 74.2844 110.752 73.9433C110.429 73.6022 110.01 73.3674 109.55 73.2697C108.73 73.1097 107.87 73.3997 107.7 75.1297C107.548 76.0379 107.731 76.9705 108.214 77.7541C108.698 78.5376 109.45 79.1189 110.33 79.3897L119.1 89.7797C119.324 90.044 119.641 90.2122 119.985 90.2494C120.329 90.2866 120.675 90.1901 120.95 89.9797L125.28 86.6797L121.7 82.2397Z",
    fill: "#A48165"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M125.73 77.7098L120.73 82.5198L124.73 87.5198L126.73 85.9598L128.1 95.7998C130.299 97.6799 132.928 98.9892 135.753 99.6118C138.579 100.234 141.514 100.151 144.3 99.3698L140.87 83.4498L143.57 82.8498L141.5 78.2598C140.905 76.9536 139.899 75.8785 138.634 75.1994C137.37 74.5202 135.918 74.2745 134.5 74.4998L131.08 75.0598C129.069 75.3778 127.202 76.3023 125.73 77.7098Z",
    fill: "#61B8FF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M120.95 82.8296L123.71 87.8596L124.49 87.2596L120.95 82.8296Z",
    fill: "#7B614C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5801 103.39L69.6501 105.45L74.2001 100.9",
    stroke: "#7FDD53",
    strokeWidth: 1.06,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5901 80.3496V103.05H84.5901",
    stroke: "#CBCBCB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeDasharray: "3 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.6ff96e280f3e65b0955003742b27b877.svg";
export { ForwardRef as ReactComponent };